import React from 'react'

export default function ActivityLogsActive() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.8333 2.5H4.16667C3.24583 2.5 2.5 3.24583 2.5 4.16667V15.8333C2.5 16.7542 3.24583 17.5 4.16667 17.5H15.8333C16.7542 17.5 17.5 16.7542 17.5 15.8333V4.16667C17.5 3.24583 16.7542 2.5 15.8333 2.5Z" stroke="black" fill="none" strokeWidth="1.5" />
      <path d="M5.83333 6.66667H14.1667" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M5.83333 10H12.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M5.83333 13.3333H10.8333" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  )
}